'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateGiftCatalog = updateGiftCatalog;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common');

var cartService = abp.services.api.cartB2c;

function updateGiftItems(availablePoints) {
    (0, _jquery2.default)('[data-gift-price]').each(function () {
        var giftPrice = parseInt((0, _jquery2.default)(this).attr('data-gift-price'));

        (0, _jquery2.default)(this).toggleClass('p--fade', giftPrice >= availablePoints);

        (0, _jquery2.default)(this).find('form a').each(function () {
            (0, _jquery2.default)(this).toggleClass('disabled', giftPrice >= availablePoints);
        });
    });
}

function updateGiftCatalog() {
    cartService.getLoyaltyPointsRemaining().then(function (result) {
        var remainingPoints = parseInt(result);

        updateGiftItems(remainingPoints);

        (0, _jquery2.default)('#loyaltyPointsRemaining').html(Resx.App.LoyaltyPointsRemaining.replace("{0}", remainingPoints));
    });
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/gift-list-updater.js
// module id = 1047
// module chunks = 0